import { atomWithStorage } from "jotai/utils";
export type ColorSchemeType = "light" | "dark" | "system";

export const colorSchemeAtom = atomWithStorage("colorScheme", "system");
